<template>
  <el-drawer
    v-if="visible"
    :visible="visible"
    :title="$l('INDEX.title_label_detail') || '查看详情'"
    show-close
    top="10vh"
    :size="1000"
    direction="rtl"
    @close="close"
    :close-on-click-modal="false"
    :wrapper-closable="false"
    :modal-append-to-body="false"
    :modal="true"
  >
    <Main
      class="ml-4 mr-4"
      ref="main"
      @reload="$emit('reload')"
      @close="close()"
      :subsOrderEventLogCode="subsOrderEventLogCode"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.main.cancel()">
        {{ this.$l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="$refs.main.save()">
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </span>
  </el-drawer>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    subsOrderEventLogCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
